import React from 'react';


const EmojiIcon = () => (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      fillOpacity='0.5'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9 7.5C9 8.32843 8.32843 9 7.5 9C6.67157 9 6 8.32843 6 7.5C6 6.67157 6.67157 6 7.5 6C8.32843 6 9 6.67157 9 7.5Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14 7.5C14 8.32843 13.3284 9 12.5 9C11.6716 9 11 8.32843 11 7.5C11 6.67157 11.6716 6 12.5 6C13.3284 6 14 6.67157 14 7.5Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.42662 11.1807C5.87907 10.864 6.5026 10.9741 6.81932 11.4265C7.30834 12.1251 8.21252 12.9219 9.29096 13.1459C10.275 13.3503 11.6411 13.1262 13.2568 11.331C13.6263 10.9205 14.2585 10.8872 14.6691 11.2567C15.0796 11.6261 15.1128 12.2584 14.7434 12.6689C12.759 14.8738 10.7085 15.483 8.88421 15.1041C7.15432 14.7447 5.8585 13.5415 5.18085 12.5734C4.86414 12.121 4.97417 11.4974 5.42662 11.1807Z'
        fill='white'
      />
    </svg>
);

export default EmojiIcon;
